import { useDispatch, useOrderProduct } from '@witmetrics/data-store';
import { API } from '@/api';
import { showSuccessToaster } from '@/utils/toasters';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import { TrashIcon } from '@/icons';
import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type DeleteOrderProductDialogProps = {
  orderProductId: number;
  onDelete?: (orderProductId: number) => void;
  onClose: () => void;
};

export default function DeleteOrderProductDialog({
  orderProductId,
  onDelete,
  onClose,
}: DeleteOrderProductDialogProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const orderProduct = useOrderProduct(orderProductId);
  const [isDeleting, toggleDeleting] = useToggle();

  const handleDelete = async () => {
    try {
      toggleDeleting(true);
      await API.Orders.removeOrderProduct(orderProductId);
      dispatch.deleteOrderProduct({ orderProductId });
      onDelete?.(orderProductId);
      showSuccessToaster('Product deleted');
      toggleDeleting(false);
      onClose();
    } catch (err) {
      toggleDeleting(false);
      onApiError(err, 'Error deleting product');
    }
  };

  return (
    <DefaultDialog
      disabled={isDeleting}
      pending={isDeleting}
      variant="confirm"
      icon={<TrashIcon size="1.375rem" />}
      confirmLabel="Delete"
      pendingLabel="Deleting"
      title="Delete product"
      message={
        <>
          Are you sure you want to remove this{' '}
          <b>{orderProduct ? orderProduct.product.name : 'product'}</b>? This
          action cannot be undone.
        </>
      }
      onCancel={onClose}
      onConfirm={handleDelete}
      onClose={onClose}
    />
  );
}
